import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { useScroll } from 'framer-motion';
import { FC, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import ScrollToTop from 'react-scroll-to-top';

import { FloatingInstagramButton } from '../componentes/FloatingInstagramButton';
import { FloatingWhatsappButton } from '../componentes/FloatingWhatsappButton';
import Beneficios from '../componentes/sumate/beneficios.component';
import Intro from '../componentes/sumate/intro.component';
import Oportunidades from '../componentes/sumate/oportunidades.component';
import { config } from '../config/config';
import { setKey } from '../stores/sharedSlice';
import { useAppDispatch } from '../stores/store';
import IntoFilo from '../componentes/sumate/IntoFilo.component';

// helper para obtener parametros
// import './home.scss';

//   position: absolute;
//   bottom: ${props => props.$size * (props.$row - 1)}px;
//   right: ${props => props.$size * (props.$col - 1)}px;
//   width: ${props => props.$size}px;
//   height: ${props => props.$size}px;
//   background-color: rgba(255, 255, 255, ${props => props.$alpha}); /* Color blanco semitransparente */
//   border-radius: 0px;
//   z-index: 3; /* Asegura que esté por encima del overlay */
const Filo: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setKey('Filo'));
  }, []);

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1024px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });

  const titulo = config.TITULO;
  const { scrollYProgress } = useScroll();
  return (
    <>
      <ScrollToTop smooth component={<ArrowCircleUpIcon />} style={{ left: '30px' }} />
      <Beneficios isDesktop={isDesktop} isMobile={isMobile} isTablet={isTablet} />
      <IntoFilo isDesktop={isDesktop} isMobile={isMobile} isTablet={isTablet} />
      <Intro isDesktop={isDesktop} isMobile={isMobile} isTablet={isTablet} />
      <Oportunidades isDesktop={isDesktop} isMobile={isMobile} isTablet={isTablet} />
    </>
  );
};

export default Filo;
